import { render, staticRenderFns } from "./PointsPolv.vue?vue&type=template&id=7e2c7a44"
import script from "./PointsPolv.vue?vue&type=script&lang=js"
export * from "./PointsPolv.vue?vue&type=script&lang=js"
import style0 from "./PointsPolv.vue?vue&type=style&index=0&id=7e2c7a44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports